import { useEffect, useRef } from 'react';

export default function usePrevious(value) {
  const ref = useRef();
  // eslint-disable-next-line no-return-assign, no-void
  useEffect(() => void (ref.current = value), [value]);
  return ref.current;
}
